export default {
  brands: { weinview: '威纶通', weintek: '威纶科技' },
  scan: {
    Product_Verification: '产品授权验证',
    Scan_the_QR_code: '请扫描贴纸上的二维码',
    Scan_msg: '产品贴纸上的二维码会开启该产品的验证页面，请使用手机相机扫描，并以扫描后开启的页面为准。',
    Enter_manually: '手动输入 SN 与验证码'
  },
  home: {
    Product_Verification: '{brand}产品授权验证',
    Product_Verification_generic: '产品授权验证',
    Sticker_SN: '贴纸 SN',
    Please_enter_the_SN_from_the_sticker: '请输入贴纸上记载的SN',
    Verification_Code: '验证码',
    Please_scratch_off_msg: '刮开银漆，取得验证码',
    Verify: '点击验证',
    Language: '语言',
    Please_wait_msg: '请稍等{qty}秒',
    You_are_not_human: '你不是人类',
    Please_check_I_am_not_a_robot: '请勾选「我不是机器人」',
    Verification_failed_please_try_again: '验证失败，请稍后再试',
    Serial_number_error: '请输入9个字符的SN',
    Serial_number_length_left: '还需要填写{qty}个字符',
    Serial_number_length_error: 'SN长度为9个字符'
  },
  first: {
    Product_Verification: '{brand}产品授权验证',
    Product_Verification_generic: '产品授权验证',
    Result_Verified: '验证结果：正版授权',
    This_is_a_first_time_verification_msg: '此为首次验证，感谢您购买{brand}的人机界面产品。',
    This_is_a_first_time_verification_msg_generic: '此为首次验证，感谢您购买本公司的人机界面产品。'
  },
  notFirst: {
    Product_Verification: '{brand}产品授权验证',
    Product_Verification_generic: '产品授权验证',
    Result_Verified: '验证结果：正版授权',
    This_is_not_a_first_time_verification_msg: '非首次验证，感谢您购买{brand}的人机界面产品。',
    This_is_not_a_first_time_verification_msg_generic: '非首次验证，感谢您购买本公司的人机界面产品。',
    Date_of_first_verification: '首次验证时间',
    Our_record_indicates_this_verification_msg: '你查询的授权已被查询过，如果该记录非您查询，此授权码可能已经被抄袭，有关产品亦有赝品之疑，如有疑问欢迎联络{brand}。',
    Our_record_indicates_this_verification_msg_generic: '你查询的授权已被查询过，如果该记录非您查询，此授权码可能已经被抄袭，有关产品亦有赝品之疑，如有疑问欢迎联络我们。'
  },
  fail: {
    Product_Verification: '{brand}产品授权验证',
    Product_Verification_generic: '产品授权验证',
    Result_Failed: '验证结果：验证失败，或为非法授权',
    The_verification_code_you_entered_is_invalid_msg: '请检查您输入的内容，内容一致，您所查询的授权则非正确授权码，有赝品之疑，如有疑问欢迎联络{brand}。',
    The_verification_code_you_entered_is_invalid_msg_generic: '请检查您输入的内容，内容一致，您所查询的授权则非正确授权码，有赝品之疑，如有疑问欢迎联络我们。'
  }
}
